import { forwardRef } from "react"
import InputContainerStyled from "@Theme/common/Input.styled"
import { IPropsInput } from "@Interfaces/IPropsInput"

const Input = forwardRef<null, IPropsInput>(
  ({ type, placeHolder, label, name, className, autocompleteValue, value, onChange }, ref) => {
    return (
      <InputContainerStyled className={className}>
        {label && <label htmlFor={name}>{label}</label>}
        <input
          type={type}
          placeholder={placeHolder}
          id={name}
          name={name}
          autoComplete={autocompleteValue}
          ref={ref}
          value={value}
          onChange={onChange}
        />
      </InputContainerStyled>
    )
  },
)

export default Input
